<div class="background">
  <div class="container-fluid">
    <div class="d-flex flex-row align-items-center justify-content-between">
      <div class="p-2 flex-grow-1">
        <h2 class="heading">Devanning History</h2>
      </div>

      <!-- ACTION dropdown aligned to the right -->
      <div class="p-2">
        <div class="drpchildctrl d-flex align-items-center">
          <label class="searchLable me-2 mb-0">ACTION</label>
          <p-dropdown
            [virtualScroll]="true"
            [itemSize]="30"
            placeholder="Select"
            [style]="{ width: '200px', height: '25px' }"
            scrollHeight="100px"
            [options]="actionOptions"
            optionLabel="action_name"
            [appendTo]="'body'"
            [autoWidth]="false"
            [ngModel]="selectedAction"
            (onChange)="onActionSelect($event.value)"
            [filterBy]="'action_name'"
          ></p-dropdown>
        </div>
      </div>
    </div>
  </div>

  <div class="successMessage alert-dismissible">
    <div *ngIf="successMessage" class="alert alert-warning" role="alert">
      {{ successMessage }}
      <button
        type="button"
        class="btn-close"
        (click)="removeMessage()"
        data-bs-dismiss="alert"
        aria-label="Close"
      ></button>
    </div>
    <div *ngIf="warningMessage" class="alert alert-warning" role="alert">
      {{ warningMessage }}
      <button
        type="button"
        class="btn-close"
        (click)="removeMessage()"
        data-bs-dismiss="alert"
        aria-label="Close"
      ></button>
    </div>
  </div>
  <div class="container-fluid">
    <div class="row">
      <div class="card">
        <div class="container-fluid">
          <div class="row">
            <div class="col-xl-1 col-md-1 col-sm-3">
              <div class="drpchildctrl">
                <span class="v1"></span>
                <label class="searchLable">DOCK</label>

                <p-dropdown
                  [options]="llpDockList"
                  [(ngModel)]="selectedDock"
                  [filter]="true"
                  [virtualScroll]="false"
                  [itemSize]="25"
                  [showTransitionOptions]="'0ms'"
                  placeholder="--Select--"
                  optionLabel="llpDocks"
                  [resetFilterOnHide]="true"
                  [hideTransitionOptions]="'0ms'"
                  autoWidth="true"
                  [filterBy]="'llpDocks'"
                  [panelStyle]="{ width: '65%' }"
                  [style]="{ width: '100%' }"
                  (onChange)="dockChange()"
                  appendTo="body"
                  scrollHeight="180px"
                >
                </p-dropdown>
              </div>
            </div>
            <div class="col-xl-1 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <span class="v1"></span>
                <label class="searchLable">KANBAN </label>
                <p-dropdown
                  [(ngModel)]="selectedKanban"
                  [options]="kanbanList"
                  [showTransitionOptions]="'0ms'"
                  [hideTransitionOptions]="'0ms'"
                  [virtualScroll]="true"
                  [itemSize]="25"
                  autoWidth="false"
                  placeholder="--Select--"
                  [style]="{ width: '100%' }"
                  [resetFilterOnHide]="true"
                  optionLabel="kanban"
                  [panelStyle]="{ width: '120%' }"
                  [filter]="true"
                  appendTo="body"
                  (onChange)="onKanbanChange()"
                  [filterBy]="'kanban'"
                  [readonly]="kanbanselect"
                  [disabled]="disableKanban"
                >
                </p-dropdown>
              </div>
            </div>
            <div class="col-xl-1 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <span class="v1"></span>
                <label class="searchLable">PART NO</label>
                <p-dropdown
                  [(ngModel)]="selectedPartNo"
                  [options]="partNoList"
                  [showTransitionOptions]="'0ms'"
                  [hideTransitionOptions]="'0ms'"
                  [virtualScroll]="true"
                  [itemSize]="25"
                  autoWidth="false"
                  placeholder="--Select--"
                  [style]="{ width: '100%' }"
                  [resetFilterOnHide]="true"
                  optionLabel="item_id"
                  [panelStyle]="{ width: '140%' }"
                  [filter]="true"
                  appendTo="body"
                  (onChange)="onPartNoChange()"
                  [filterBy]="'item_id'"
                  [readonly]="partSelect"
                  [disabled]="disablePartNumber"
                >
                </p-dropdown>
              </div>
            </div>

            <div class="col-xl-1 col-md-1 col-sm-4">
              <div class="drpchildctrl">
                <label class="searchLable searchLabelText"
                  >CONTAINER FROM</label
                >
                <p-dropdown
                  [options]="containerList"
                  [(ngModel)]="containerFrom"
                  [filter]="true"
                  [virtualScroll]="true"
                  [itemSize]="25"
                  [showTransitionOptions]="'0ms'"
                  placeholder="--Select--"
                  optionLabel="container"
                  [resetFilterOnHide]="true"
                  [hideTransitionOptions]="'0ms'"
                  autoWidth="true"
                  [filterBy]="'container'"
                  [max]="containerTo"
                  [panelStyle]="{ width: '65%' }"
                  [style]="{ width: '100%' }"
                  appendTo="body"
                  scrollHeight="180px"
                >
                </p-dropdown>
              </div>
            </div>
            <div class="col-xl-1 col-md-2 col-sm-4">
              <div class="drpchildctrl">
                <label class="searchLable searchLabelText">CONTAINER TO</label>
                <p-dropdown
                  [options]="containerList"
                  [(ngModel)]="containerTo"
                  [filter]="true"
                  [virtualScroll]="true"
                  [itemSize]="25"
                  [showTransitionOptions]="'0ms'"
                  placeholder="--Select--"
                  optionLabel="container"
                  [resetFilterOnHide]="true"
                  [hideTransitionOptions]="'0ms'"
                  autoWidth="true"
                  [filterBy]="'container'"
                  [panelStyle]="{ width: '65%' }"
                  [style]="{ width: '100%' }"
                  appendTo="body"
                  scrollHeight="180px"
                >
                </p-dropdown>
              </div>
            </div>
            <div class="col-xl-1 col-md-2 col-sm-3 me-4">
              <div class="drpchildctrl">
                <label class="searchLable searchLabelText"
                  >STOCKING DATE FROM</label
                >
                <p>
                  <input
                    [(ngModel)]="stockingDateFrom"
                    class="form-control-sm"
                    type="date"
                    autoWidth="false"
                  />
                </p>
              </div>
            </div>
            <div class="col-xl-1 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <label class="searchLable searchLabelText"
                  >STOCKING DATE TO</label
                >
                <p>
                  <input
                    [(ngModel)]="stockingDateTo"
                    class="form-control-sm"
                    type="date"
                    autoWidth="false"
                  />
                </p>
              </div>
            </div>
            <div class="col-xl-2 col-md-2 col-sm-3 reset_btn">
              <label class="resetIcon" (click)="onResetDropDown()">
                <img
                  src="./assets/images/Group 115380.png"
                  alt="refresh icon"
                />
                Reset
              </label>
              <span class="vertical"></span>
              <button class="search_btn" (click)="onSearch(0)">SEARCH</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-4">
        <!-- <img src="./assets/images/edit.svg" (click)="onEditMode()"  alt="edit button icon" title="Edit" class="img-tool"> -->
        <img
          class="img-tool"
          src="./assets/images/download.svg"
          alt="download icon"
          title="Download"
          (click)="exportAsXLSX()"
        />
      </div>
      <div class="col-4"></div>
      <div class="col-sm-4">
        <div class="records">
          <label class="page-drpdwn-label">RECORDS / PAGE:</label>
          <select
            class="page-drpdwn"
            (change)="onPageSizeChanged()"
            [(ngModel)]="paginationPageSize"
          >
            <option value="10" selected>10</option>
            <option value="30">30</option>
            <option value="50">50</option>
            <option value="{{ rowData.length }}">All</option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <div id="dvgrid" class="gridStyle">
    <div class="grid-heading" *ngIf="rowData?.length">
      <span><strong>Kanban:</strong> {{ res_kanbanNo }}</span>
      <span><strong>Part Number:</strong> {{ res_partNo }}</span>
      <span><strong>Description:</strong> {{ res_part_description }}</span>
      <span><strong>Order Lot:</strong> {{ order_lot }}</span>
    </div>
    <app-grid
      class="table-outer"
      #osPartsGrid
      [columnDefs]="columnDefs"
      [rowData]="rowData"
      [rowSelection]="rowSelection"
      [gridOptions]="gridOptions"
      [pagination]="pagination"
      [paginationPageSize]="paginationPageSize"
      [context]="context"
      [suppressClickEdit]="suppressClickEdit"
      [frameworkComponents]="frameworkComponents"
      [tooltipShowDelay]="tooltipShowDelay"
      [tooltipMouseTrack]="true"
      [editType]="editType"
      [detailRowAutoHeight]="true"
    >
    </app-grid>
    <div class="result-info" *ngIf="rowData?.length">
      <span>{{ rowData.length }} Records</span> –
      <span>Total Stocked Qty: {{ totalStockedQty }}</span> –
      <span>Average Stocked Qty Per Day: {{ avgStockedQtyPerDay }}</span>
    </div>
  </div>
</div>

<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
>
  <p style="font-size: 20px; color: white">Loading... Please wait...</p>
</ngx-spinner>
